/** Side-effect: register catalog widgets, then rich custom overrides. */
import './widgets/registerCatalog';
import './widgets/custom';
import './widgets/panels';
import './widgets/aliases';
